"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderingType = exports.LayoutServicePageState = exports.EDITING_COMPONENT_ID = exports.EDITING_COMPONENT_PLACEHOLDER = void 0;
/**
 * Static placeholder name used for component rendering
 */
exports.EDITING_COMPONENT_PLACEHOLDER = 'editing-componentmode-placeholder';
/**
 * Id of wrapper for component rendering
 */
exports.EDITING_COMPONENT_ID = 'editing-component';
/**
 * Layout Service page state enum
 */
var LayoutServicePageState;
(function (LayoutServicePageState) {
    LayoutServicePageState["Preview"] = "preview";
    LayoutServicePageState["Edit"] = "edit";
    LayoutServicePageState["Normal"] = "normal";
})(LayoutServicePageState = exports.LayoutServicePageState || (exports.LayoutServicePageState = {}));
/**
 * Editing rendering type
 */
var RenderingType;
(function (RenderingType) {
    RenderingType["Component"] = "component";
})(RenderingType = exports.RenderingType || (exports.RenderingType = {}));
